// Shared entry point for the public user-profile drawer. Every place a user
// is displayed (feed byline, comments, marketplace seller, race lists) calls
// this instead of appState.openDrawer directly, so adding a new link point is
// a one-liner and the guards live in one place.

// Returns true when the drawer was opened. Guards on a real user id — race
// and convention news rows and imported contestants have no linked user, and
// must not open an empty drawer.
export function openUserProfileDrawer(appState, { userId, name, image, faceBox } = {}) {
    const id = parseInt(userId, 10);
    if (!(id > 0)) {
        return false;
    }
    // Stack above whatever drawer the click came from; level 1 when none open.
    const drawerLevel = Math.max(appState.getTopMostDrawer() + 1, 1);
    appState.openDrawer('publicUserProfile', {
        height: appState.drawerHeightMedium,
        title: name,
        userId: id,
        name,
        image,
        faceBox,
    }, drawerLevel);
    return true;
}

export default { openUserProfileDrawer };
